import { UserManager, WebStorageStateStore } from "oidc-client-ts";
import { env } from "~/env";

let _userManager: UserManager | null = null;

/**
 * Returns the singleton UserManager instance.
 * Only call this on the client (typeof window !== 'undefined').
 */
export function getUserManager(): UserManager {
  if (!_userManager) {
    _userManager = new UserManager({
      authority: env.VITE_OIDC_AUTHORITY,
      client_id: env.VITE_OIDC_CLIENT_ID,
      redirect_uri: `https://${window.location.hostname}/auth/callback`,
      response_type: "code",
      scope: "openid profile email",
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      stateStore: new WebStorageStateStore({ store: window.localStorage }),
      automaticSilentRenew: true,
    });
  }
  return _userManager;
}
